import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../services/api.service';

@Component({
  selector: 'ngx-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.scss']
})
export class TermsAndConditionsComponent implements OnInit {

  constructor(private _aS: ApiService) { }
  public staticPages: any = [];
    staticPage: any;

  ngOnInit(): void {
    this.getStatic();
  }


  getStatic() {
    this._aS.getStaticPages(19).subscribe((res) => {
        this.staticPages = res;
        console.log(this.staticPages)
    })
  }

}
